import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { ModalAddAttachment } from './modalAddAttachments';
import { useAttachmentsField } from './hooks/useAttachmentsField';
import { AttachmentFieldContainer } from './style';
import { AttachmentList } from './attachmentList';
import { ActionButton } from '../style';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';

const { Text } = Typography;

export const CustomAttachmentField = ({
  labelDecorator,
  field,
  value: defaultValue,
  onChange,
  readOnly,
  extendedFormEnabled,
}) => {
  const { translate: t } = useDictionaryTranslation();
  const [showModal, setShowModal] = useState(false);
  const { attachmentList } = useAttachmentsField({
    defaultValue,
  });

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = ({ value } = {}) => {
    if (Array.isArray(value)) {
      onChange(value);
    }
    setShowModal(false);
  };

  return (
    <>
      {!readOnly ? (
        <AttachmentFieldContainer>
          <Text className="attachment-text">{t('nAttachmentFiles', { n: attachmentList.length })}</Text>
          <ActionButton className="add-attachment" type="primary" icon={<PlusOutlined />} onClick={openModal} />
        </AttachmentFieldContainer>
      ) : (
        <>
          <Text className="attachment-text">
            <b>{field.label}: </b>
            {extendedFormEnabled ? <br /> : null}

            {t('nAttachmentFiles', { n: attachmentList.length })}
            {labelDecorator}
          </Text>
          <AttachmentList defaultValue={attachmentList} readOnly={readOnly} />
        </>
      )}
      {showModal ? (
        <ModalAddAttachment
          defaultValue={defaultValue}
          title={field.label}
          show={showModal}
          handleClose={closeModal}
          limit={field.limit}
        />
      ) : null}
    </>
  );
};

CustomAttachmentField.propTypes = {
  field: PropTypes.shape({
    idInput: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.array,
    limit: PropTypes.number,
    obligatory: PropTypes.bool,
  }),
  value: PropTypes.array,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  extendedFormEnabled: PropTypes.bool,
  labelDecorator: PropTypes.string,
};
